import { createSlice } from "@reduxjs/toolkit";
import BrandingFooter from "../../components/Footer/BrandingFooter";
import { Fragment } from "react";

const initialState = {
  footerComponent: <BrandingFooter />,
  popupComponent: <Fragment />,
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setFooterComponent: (state, action) => {
      state.footerComponent = action.payload;
    },
    setPopupComponent: (state, action) => {
      state.popupComponent = action.payload;
    },
  },
});

export const { setFooterComponent, setPopupComponent } = uiSlice.actions;

export default uiSlice.reducer;
